import React from 'react';
import { Reveal } from './Reveal';
import type { PillarPageContent } from '../types/pillarPage';
type ManifestoSectionProps = {
  content: PillarPageContent['manifesto'];
};
export function ManifestoSection({
  content
}: ManifestoSectionProps) {
  return <section className="w-full bg-ink py-32 lg:py-48" data-id="element-165" data-mp="a4ndligklw5e">
      <div className="mx-auto w-full max-w-[1000px] px-6 sm:px-10" data-id="element-166" data-mp="eyi4p6yi9dei">
        <Reveal data-id="element-167" data-mp="izaeq2f7bmbu">
          <h2 className="text-center text-[10px] font-bold uppercase tracking-label text-accent" data-id="element-168" data-mp="iztlqo3bcqb3">
            {content.eyebrow}
          </h2>
          <p className="mt-8 text-center text-3xl font-extrabold uppercase leading-[1.05] tracking-[-0.02em] text-bone sm:text-5xl lg:text-[4rem]" data-id="element-169" data-mp="nwaankic78p8">
            {content.title}
          </p>
        </Reveal>

        <div className="mt-20 space-y-10" data-id="element-170" data-mp="xu87uxi6cftz">
          {content.lines.map((line, i) => <Reveal key={line} delay={0.04 * i} data-id="element-171" data-mp="2uqffxsp7bon6" data-mpi={i}>
              <p className="text-center text-lg font-semibold leading-snug tracking-[-0.01em] text-ash sm:text-2xl" data-id="element-172" data-mp="2zn5w0g10ak8l">
                {line}
              </p>
            </Reveal>)}
        </div>
      </div>
    </section>;
}